import Controller from 'lib/controller'
import Collection from 'collection/collection'
import dataProvider from 'service/data_provider'
import CommunityLinkView from 'bundle/localcommunity/view/community_link'
import ToggleItemsView from 'view/toggle_items'
import CarouselView from 'view/carousel'
import SecondaryNavigationView from 'component/secondary_navigation/secondary_navigation'
import TertiaryNavigationView from 'component/tertiary_navigation/tertiary_navigation'
import CollapsibleTextView from 'view/collapsible_text'
import windowView from 'shared/view/window'
import SelectBoxView from 'view/select_box'

const AboutController = Controller.extend({
    options: {
        toggleItemsSelector: '.js-toggle-items',
    },

    initialize() {
        this._initCommunityLinks()
        this.initSubview(SecondaryNavigationView)
        this.initSubview(TertiaryNavigationView)

        this.initSubview(CarouselView, {
            el: '.js-carousel-wrapper',
            autoplay: true,
            infinite: true,
        })

        this.initSubview(SelectBoxView, {
            el: this.$('.js-location-country-input'),
            placeholder: '',
        })

        this.initSubview(SelectBoxView, {
            el: this.$('.js-content-subject'),
            placeholder: '',
        })

        this.$toggleItems = this.$(this.options.toggleItemsSelector)

        if (this.$toggleItems.length) {
            this.initSubview(ToggleItemsView, {
                el: this.$toggleItems,
                location: (document.location.hash || '').substr(1),
            })
        }

        if (windowView.isMobile()) {
            this.$('.js-collapsible-text').each((index, element) => {
                this.initSubview(CollapsibleTextView, { el: element })
            })
        }
    },

    _initCommunityLinks() {
        const collection = new Collection(dataProvider.get('markers'))
        const communities = collection.reduce((acc, val) => ({ ...acc, [val.id]: val }), {})

        this.$('.js-community-link').each((index, element) => {
            const data = this.$(element).data()
            const model = communities[data.id]

            this.initSubview(CommunityLinkView, {
                el: element,
                model,
            })
        })
    },
})

export default new AboutController()
